/**
 * Skin quiz matching: picks the routine for a set of answers.
 *
 * A scenario field that is null/empty means "any". Among the scenarios whose
 * specified fields all equal the answers, the most specific wins
 * (concern 4, skin type 2, age 1); ties go to the last one (WordPress parity).
 *
 * Mirrors App\Services\SkinQuiz\SkinQuizMatcher in the lavido-comax-shopify app;
 * both run the shared cases in tests/skin-quiz-matcher-cases.json.
 */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.SkinQuizMatcher = api;
  }
})(typeof self !== 'undefined' ? self : this, function () {
  const WEIGHTS = { concern: 4, skin_type: 2, age: 1 };

  const isAny = (value) => value === null || value === undefined || value === '';

  function specificity(scenario) {
    return Object.keys(WEIGHTS).reduce(
      (score, field) => (isAny(scenario[field]) ? score : score + WEIGHTS[field]),
      0
    );
  }

  function isCandidate(scenario, answers) {
    return Object.keys(WEIGHTS).every(
      (field) => isAny(scenario[field]) || scenario[field] === answers[field]
    );
  }

  /** @returns {{scenario: object, index: number, specificity: number} | null} */
  function match(scenarios, answers) {
    let best = null;
    scenarios.forEach((scenario, index) => {
      if (!isCandidate(scenario, answers)) return;
      const score = specificity(scenario);
      if (best === null || score >= best.specificity) {
        best = { scenario, index, specificity: score };
      }
    });
    return best;
  }

  return { match, specificity, WEIGHTS };
});
